import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import api from "@/api";
import { computed, PropType } from "vue";
import { Client } from "@/types";
import { useUiStore } from "@/stores/ui";
import AdministrationStatus from "@/components/general/administration-status/AdministrationStatus.vue";
import { AdministrationStatus as AdministrationStatusType } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'AcumulusClientCreate',
  props: {
    client: {
        type: Object as PropType<Client>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const uiStore = useUiStore();

const createAcumulusClient = () => {
    api.createAcumulusClient(props.client.id).then((response) => {
        uiStore.message("Klant aangemaakt in acumulus...");
        // wait for the snackbar to be able to show the second message
        setTimeout(() => {
            props.client.acumulus_client_id = response;
        }, 200);
    });
};

const statuses = computed<AdministrationStatusType[]>(() => {
    return [
        {
            label: "Acumulus",
            done: props.client.acumulus_client_id === 0 ? "idle" : "success",
        },
    ];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdministrationStatus, {
    onAction: createAcumulusClient,
    "action-label": "Maak klant aan in Acumulus",
    "done-label": "Klant aangemaakt in Acumulus",
    statuses: statuses.value
  }, null, 8, ["statuses"]))
}
}

})